import {
  CalculateOutlined,
  FolderCopyOutlined,
  FileCopyOutlined,
  GavelOutlined,
  InsertDriveFileOutlined,
  TextSnippetOutlined
} from "@mui/icons-material";
import { BotIcon } from "lucide-react";
import img1 from "../Images/usefull/pic3.jpg";
import img2 from "../Images/usefull/pic2.jpg";
import img3 from "../Images/usefull/pic5.jpg";
import img4 from "../Images/usefull/pic4.jpg";
import img5 from "../Images/usefull/pic1.jpg";
import img6 from "../Images/usefull/pic6.jpg";
import img7 from "../Images/usefull/pic7.jpeg";


export const servicesData = [
    {
        id: 1,
        name: 'online_appeals',
        icon: <InsertDriveFileOutlined style={{ fontSize: '40px' }} />,
        link: '/electron-filing',
        backgroundImage: img1,
    },
    {
        id: 2,
        name: 'request_copies',
        icon: <FileCopyOutlined style={{ fontSize: '40px' }} />,
        link: '/act-request',
        backgroundImage: img2,
    },
    {
        id: 3,
        name: 'collection_decisions',
        icon: <TextSnippetOutlined style={{ fontSize: '40px' }} />,
        link: '/collection-decisions',
        backgroundImage: img6,
    },
    {
        id: 4,
        name: 'sale',
        icon: <GavelOutlined style={{ fontSize: '40px' }} />,
        link: '/sale',
        backgroundImage: img5,
    },
    {
        id: 5,
        name: 'document_sample',
        icon: <FolderCopyOutlined style={{ fontSize: '40px' }} />,
        link: '/document-sample-list',
        backgroundImage: img4,
    },
    {
        id: 6,
        name: 'calculator',
        icon: <CalculateOutlined style={{ fontSize: '40px' }} />,
        link: '/calculator',
        backgroundImage: img3,
    },
    {
        id: 7,
        name: 'Kazyýet AI',
        icon: <BotIcon size={40} />,
        link: '/court-ai',
        backgroundImage: img7,
    },
];